
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";

const asnModule = getModule(AsnModule);

import _ from "lodash";
import { RefNum } from "@/models/api/asn/refnum";

interface ValueOption {
  label: string;
  value: string;
}

@Component({
    components: {
    Select
  }
})
export default class ReferenceNumberLine extends Vue {

    @Prop()
    ReferenceTypes: ValueOption[];

    @Prop({ default: []})
    ColumnMap: string[];

    @Prop({ default: null })
    RefNumLine: RefNum;

    IsLoadingOptions: boolean = false;

    MapTo: string = "";
    ReferenceType: ValueOption = { label: "", value: "" };
    ValueType: string = "";
    Value: string | any = "";
    TextValue: string = "";

    ValueTypeOptions: string[] = [
        "Column",
        "Text",
        "Date"
    ];

    ValueOptions: ValueOption[] = [];

    @Watch("MapTo")
    async selectedMapChanged(newValue){
        await this.onRefNumUpdated();
    }

    @Watch("ValueType")
    async selectedValueTypeChanged(newValue){
        this.IsLoadingOptions = false;
        this.ValueOptions = [];

        if (newValue !== 'Text'){
            this.TextValue = "";
        }

        if (newValue === 'Date'){
            this.ValueOptions.push({ label: 'Today', value: 'Today' });
            this.ValueOptions.push({ label: 'Next Business Day', value: 'Next Business Day' });
        }

        this.IsLoadingOptions = false;

        await this.onRefNumUpdated();
    }

    @Watch("Value")
    selectedValueChanged(newValue){
        this.onRefNumUpdated();
    }

    @Watch("TextValue")
    selectedTextValueChanged(newValue){
        this.onRefNumUpdated();
    }

    async onRemoveRefNum(){
        this.$emit('refnum-removed', this.RefNumLine);
    }

    async onRefNumUpdated(){
        this.$emit('refnum-updated', 
        {   id: this.RefNumLine.id, 
            map: this.MapTo, 
            referenceType: this.ReferenceType, 
            valueType: this.ValueType, 
            value: this.Value,
            textValue: this.TextValue
        });
    }

    created(){
        this.MapTo = this.RefNumLine.map;
        this.ReferenceType = this.RefNumLine.referenceType;
        this.ValueType = this.RefNumLine.valueType;
        this.Value = this.RefNumLine.value;
        this.TextValue = this.RefNumLine.textValue;
    }
}
